import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1fe928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ring" }
const _hoisted_2 = { viewBox: "-50 -50 100 100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "0",
  cy: "0",
  r: "50"
}, null, -1))
const _hoisted_4 = ["d"]

import { computed } from "vue";
import { clamp } from "lodash";
import { sin, cos } from "@/util/math";

interface Props {
  /** value to show in center of ring */
  score?: number;
  /** range of score for normalization */
  min?: number;
  max?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppRing',
  props: {
    score: { default: 50 },
    min: { default: 0 },
    max: { default: 100 }
  },
  setup(__props: any) {

const props = __props as { score: number, min: number, max: number }



/** normalized score value */
const normalized = computed(() => {
  let value = (props.score - props.min) / (props.max - props.min);
  /** if max === min (essentially, if only one ring result to show in list) */
  if (Number.isNaN(value)) value = 0.5;
  return clamp(value, 0.05, 0.95);
});

/** arc svg path */
const d = computed(() => {
  const angle = 360 * normalized.value;
  const x = sin(angle) * 50;
  const y = -cos(angle) * 50;
  return `M 0 -50 A 50 50 0 ${angle >= 180 ? 1 : 0} 1 ${x} ${y}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(__props.score), 1),
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("path", { d: _unref(d) }, null, 8, _hoisted_4)
    ]))
  ]))
}
}

})